import Image from "next/image";
import { css } from "@emotion/react";

export default function Maintenance() {
    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-height: 90vh;
                padding: 2rem;
                background-color: var(--color-background);
                color: var(--color-text-primary);
                transition: background-color 0.2s ease, color 0.2s ease;
            `}
        >
            <div
                css={css`
                    max-width: 600px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 2rem;
                `}
            >
                <div
                    css={css`
                        position: relative;
                        width: 100%;
                        max-width: 400px;
                        aspect-ratio: 1;
                    `}
                >
                    <Image
                        src="/img/under-maintenance.png"
                        alt="Under Maintenance"
                        fill
                        style={{ objectFit: "contain" }}
                        priority
                    />
                </div>

                <div
                    css={css`
                        display: flex;
                        flex-direction: column;
                        gap: 1rem;
                    `}
                >
                    <h1
                        css={css`
                            font-size: 2rem;
                            font-weight: 700;
                            color: var(--color-text-primary);
                            margin: 0;

                            @media (max-width: 768px) {
                                font-size: 1.5rem;
                            }
                        `}
                    >
                        서비스 점검 중입니다
                    </h1>

                    <p
                        css={css`
                            font-size: 1.125rem;
                            line-height: 1.6;
                            color: var(--color-text-secondary);
                            margin: 0;

                            @media (max-width: 768px) {
                                font-size: 1rem;
                            }
                        `}
                    >
                        10월 24일 21시 ~ 25일 00시 동안 시스템 점검이 진행되고 있습니다.
                        <br />
                        잠시만 기다려 주세요!
                    </p>
                </div>
            </div>
        </div>
    );
}